import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'app/services/google-analytics.service';

@Component({
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent 
{
  constructor(private title: Title, private googleAnalyticsService: GoogleAnalyticsService) 
  {
    title.setTitle('Pagina non trovata');
  }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/area-generale/page-not-found/page-not-found.component.ts